export interface Partner {
  name: string;
  logo: string;
}

export const partners: Partner[] = [
  { name: 'University of Iceland', logo: '/hi_logo.png' },
  { name: 'Technology Development Fund', logo: '/TechDevFund_Logo_EN.png' },
  { name: 'Landspítali University Hospital', logo: '/Landspitali_Logo.png' },
  { name: 'Almannarómur', logo: '/almannaromur.png' },
];
